export default {
    PRE_VALIDATE_SELECTED: 'preValidateSelected',
    PRE_VALIDATE_SELECTED_FOR_DOCUMENT: 'preValidateSelectedForDocument',
    MODAL_CONNECT_WITH_SAVE: 'modalConnectWithSave',
}
